import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { AppUpdateService } from './updates/app-update.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, TranslocoPipe],
  styles: `
    .app-update-banner {
      position: fixed;
      inset: auto 0 0 0;
      z-index: 1000;
      display: flex;
      gap: 12px;
      align-items: center;
      justify-content: center;
      padding: 10px 16px;
      background: var(--card-bg, #fff);
      color: var(--text-primary, #111);
      border-top: 1px solid var(--border-med, #ccc);
      font-size: 14px;
    }
    .app-update-banner button {
      font: inherit;
      cursor: pointer;
      padding: 4px 12px;
      color: var(--brand-primary-on-primary, #fff);
      background: var(--brand-primary, #111);
      border: 0;
      border-radius: 999px;
    }
  `,
  template: `
    <router-outlet />
    @if (update.updateAvailable()) {
      <div class="app-update-banner" role="status" id="login-web.app.update-banner">
        <span>{{ 'app_update.available' | transloco }}</span>
        <button type="button" id="login-web.app.update-reload-button" (click)="update.reload()">
          {{ 'app_update.reload' | transloco }}
        </button>
      </div>
    }
  `,
})
export class App {
  protected readonly update = inject(AppUpdateService);
}
